module.exports = __webpack_public_path__ + "img/HSF_logo_HD.af6099a1.jpg";